import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { VoucherListFilterDto } from "../models/voucher/voucherListFilterDto";
import { Observable } from "rxjs";
import { VoucherWithResultDto } from "../models/voucher/voucherWithResultDto";
import { result } from "lodash";
import { Constants } from "../data/constants";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class VoucherService {
  endPoint = "users/api/";

  httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  constructor(private http: HttpClient) {}

  filterVouchersForPartnerLocation(
    filter: VoucherListFilterDto
  ): Observable<VoucherWithResultDto | null> {
    return this.http.post<VoucherWithResultDto | null>(
      `${environment.APP_PORT + Constants.VOUCHERS}/filter`,
      filter
    );
  }
}
